export const counter_url: string = "counter";